import resolveConfig from "tailwindcss/resolveConfig";

import tailwindConfig from "../../tailwind.config";

export const resolvedTailwindConfig = resolveConfig(tailwindConfig);

export const getResolvedThemeColors = () => {
  return resolvedTailwindConfig.theme?.colors ?? {};
};
